import React, {useEffect, useState} from "react";

import styles from "./InterviewTable.module.css";

import {Dropdown} from "primereact/dropdown";

import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { InputText } from "primereact/inputtext"
import { Button } from "primereact/button"

import {rowsToDisplay} from "../../../const";

import date from "date-and-time";
import useAllSelectedInterviews from "../../../hooks/useAllIntervals";
import { getScheduledInterviews } from "../../../utils/apiCalls";


function InterviewTable() {
  const [interviews, setInterviews] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [rows, setRows] = useState(6);
  const [firstRowIndex, setFirstRowIndex] = useState(0);
    const [isToggleSelected, setToggleSelected] = useState(false);
    const [filters, setFilters] = useState(null);
    const [globalFilterValue, setGlobalFilterValue] = useState('');

  // const rowData = useAllSelectedInterviews();
  // const currentData = rowData?.map((oldElement) => {
  //   return {
  //     nume: oldElement.users[0].firstName,
  //     prenume: oldElement.users[0].lastName,
  //     email: oldElement.users[0].email,
  //     data: new Date(oldElement.data),
  //     ora: oldElement.interval,
  //   };
  // });

  // const loadData = async () => {
  //   const interviewsData = await loadInterviews(currentData);
  //   let currentInterviews = [];

  //   if (interviewsData) {
  //     for (const element of interviewsData) {
  //       if (element) {
  //         currentInterviews.push(element);
  //       }
  //     }
  //     setInterviews(currentInterviews);
  //     setIsLoading(false);
  //   }

  // };

  // useEffect(() => {
  //   loadData();
  // }, [rowData]);


  // const onPage = (event) => {
  //   const startIndex = event.first;
  //   setFirstRowIndex(startIndex);
  // };

const loadInterviews = async (interviewsData, t) => {
  if (interviewsData === null || interviewsData === undefined) return null;

  let initialInterviews = [...interviewsData];

    if(t){
      console.log("Hello");
        initialInterviews = initialInterviews.filter((i) => {return new Date(i.interview.date) > new Date()});
        console.log(initialInterviews);
      }

  return initialInterviews.map((interview) => {
    // const now = new Date();
    // if (new Date(interview.interview.date) > now) {
      let day = date.format(new Date(interview.interview.date), "DD.MM.YYYY");
      let hour = date.format(new Date(interview.interview.date), "HH:mm");

      return { ...interview, date: day, ora: hour };
    // }
    // return interview;
  });
};
  const loadData = async (t) => {
    try {
      const interviewsData = await getScheduledInterviews();
      console.log("Fetched Interviews Data:", interviewsData);
      const formattedInterviews = await loadInterviews(interviewsData, t);
      console.log("Formatted Interviews Data:", formattedInterviews);
      let currentInterviews = [];

      if (formattedInterviews) {
        for (const element of formattedInterviews) {
          if (element) {
            currentInterviews.push(element);
          }
        }
        setInterviews(currentInterviews);
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error loading interviews:", error);
      setIsLoading(false);
    }
  };

  const toggleShow = async() => {
    const toggle = !isToggleSelected;
    setToggleSelected(toggle);
    await loadData(toggle);
  }

  useEffect(() => {
    loadData();
    initFilters();
  }, []);

  const onPage = (event) => {
    const startIndex = event.first;
    setFirstRowIndex(startIndex);
  };
  
  const renderHeader = () => {
    return (
        <div className="flex justify-content-between">
            <Button type="button" icon="pi pi-filter-slash" label="Clear" className="p-button-outlined" onClick={clearFilter} />
            <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" />
            </span>
        </div>
    )
}

 const onGlobalFilterChange = (e) => {
      const value = e.target.value;
      let _filters = { ...filters };

      _filters['global'].value = value;

      setFilters(_filters);
      setGlobalFilterValue(value);
  }

    const initFilters = () => {
      setFilters({'global': { value: null, matchMode: FilterMatchMode.STARTS_WITH },
              'firstName': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]},
              'lastName': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]},
              'email': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]},
            'date': {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]},
          'ora': {operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH}]}});
    setGlobalFilterValue('');
            };
            const clearFilter = () => {
              initFilters();
            }

const header = renderHeader();

  return (
    <div className={styles.tableContainer}>
      <div className={styles.textContainer}>
      <div className={styles.dropdownContainer}>
        <p>Alege numărul de rânduri pentru afișare</p>

        <Dropdown
          optionLabel="rows"
          value={rows}
          optionValue="rows"
          options={rowsToDisplay}
          onChange={(event) => {
            setRows(event.value);
            setFirstRowIndex(0);
          }}
          placeholder="Rows to display"
        />
      </div>
      <div className={styles.toggleWrapper}>
      <div className={styles.dropdownContainer}>
        <p>Afișează doar interviurile programate în perioada următoare</p>
                     <div className={styles.toggleRand}>
              <div className={styles.toggleCheckbox}>
  <span onClick={() => toggleShow()} className={isToggleSelected ? `${styles.checkedToggleSlider}` : `${styles.toggleSlider}`}></span></div>
  <span className={isToggleSelected ? `${styles.da}` : `${styles.nu}`}>{isToggleSelected? "Da" : "Nu"}</span></div></div>
      </div>
      </div>

      <DataTable style={{backgroundColor: "#f6d48b"}}
        value={interviews}
        loading={isLoading}
        paginator
        rows={rows}
        header={header}
        first={firstRowIndex}
        filters={filters}
        onPage={onPage}
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
        currentPageReportTemplate="Se afișează {first} - {last} din {totalRecords} interviuri"
      >
        <Column field="lastName" filter header="Nume"></Column>
        <Column field="firstName" filter header="Prenume"></Column>
        <Column field="email" filter header="Email"></Column>
        <Column field="date" header="Data" filter sortable></Column>
        <Column field="ora" filter header="Ora" sortable></Column>
      </DataTable>
    </div>
  );
}

export default InterviewTable;
